<div class="quick-metrics-grid">
  @for (item of items; track item.icon + item.value) {
    <div class="qm-tile" [class.qm-tile-sans-contour]="!avecContour" [class.maquette-statique]="item.maquette" [title]="item.tooltip ?? item.title">
      <span class="material-symbols-outlined qm-icon">{{ item.icon }}</span>
      <span class="qm-value">{{ item.value }}</span>
    </div>
  }
</div>
